import { render, staticRenderFns } from "./GroupedListItem.vue?vue&type=template&id=4b1b6382&lang=pug"
import script from "./GroupedListItem.vue?vue&type=script&lang=js"
export * from "./GroupedListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports